import { render, staticRenderFns } from "./MinhaEmpresaPerfil.vue?vue&type=template&id=4466c5b0&scoped=true&"
import script from "./MinhaEmpresaPerfil.vue?vue&type=script&lang=js&"
export * from "./MinhaEmpresaPerfil.vue?vue&type=script&lang=js&"
import style0 from "./MinhaEmpresaPerfil.vue?vue&type=style&index=0&id=4466c5b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4466c5b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSimpleTable})
